import { render, staticRenderFns } from "./CellContatos.vue?vue&type=template&id=6b9880db"
import script from "./CellContatos.vue?vue&type=script&lang=js"
export * from "./CellContatos.vue?vue&type=script&lang=js"
import style0 from "./CellContatos.vue?vue&type=style&index=0&id=6b9880db&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports